import { UploadDropzone } from 'lib-knowledge-management-common/components/imageUpload/uploadDropzone';
import { useUploadImage } from 'lib-knowledge-management-common/hooks/useUploadImage';
import { useCallback, useState } from 'react';
import { DropzoneOptions } from 'react-dropzone';

const dropzoneTitle = 'Drag and drop, or click to choose an image';
const dropzoneDescription =
  'Static image must be under 50MB in size and animated gif must be under 6MB';

export type UploadResults = {
  url: string;
  filename: string;
  width: number | undefined;
  height: number | undefined;
};

type UploadProps = {
  onUpload: (results: UploadResults) => void;
};

export function UploadImage({ onUpload }: UploadProps): JSX.Element {
  const [file, setFile] = useState<File | null>(null);
  const [uploadImage, uploadError] = useUploadImage();
  const onDrop: DropzoneOptions['onDrop'] = useCallback(
    async (acceptedFiles: File[]) => {
      // This can't happen because of the react-dropzone setting
      if (acceptedFiles.length !== 1) return;

      setFile(acceptedFiles[0]);
      const imageProperties = await uploadImage(acceptedFiles[0]);

      // If this is empty, then uploadError SHOULD be set.
      if (!imageProperties) return;

      onUpload({
        url: imageProperties.url,
        filename: imageProperties.filename,
        width: imageProperties.width,
        height: imageProperties.height,
      });
    },
    [uploadImage, onUpload],
  );

  return (
    <UploadDropzone
      padding="200"
      onDrop={onDrop}
      file={file}
      uploadError={uploadError}
      title={dropzoneTitle}
      description={dropzoneDescription}
    />
  );
}
